import { Box, IconButton, TextField } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Container = styled(Box)(({ theme }) => ({
  position: 'relative',
  marginLeft: theme.spacing(1),
}));

export const TopBottomSpacingField = styled(TextField)(({ theme }) => ({
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(1),
}));

export const CancelIconButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.error.main,
}));
